import { BASE_URL } from '@mote/helpers/constants'
import { beforeRequestHook } from '../../../client'

/**
 * @param {string} toteId
 * @return {Request}
 */
export function getSpeechRequest(toteId) {
  const request = new Request(BASE_URL + `v1/t/speech/${toteId}`, {
    method: 'POST'
  })
  beforeRequestHook(request)
  return request
}
